export interface InfoWarning {
	infoWarningID?: number;
	validFrom: string | null;
	validTo: string | null;
	type: number;
	productTypeID: string | null;
	text: string | null;
	url: string | null;
	state?: InfoWarningState;
	description: string | null;
	notifyClientByEmail: boolean;
	visibility: number;
	placement: string | null;
}

export enum InfoWarningState {
	Active = 0,
	Pending = 1,
	Expired = 2,
}
